import React from 'react';

export function NotFound() {
  return <div>Page not found.</div>;
}
